<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kmVlcG/tc-custom/9781250038302.jpg?1731883518501" alt="This image is the cover for the book Rise of the Tudors"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rise of the Tudors
      </h1>
      <p class="bookDescription body article font2">
        <p>On the morning of August 22, 1485, in fields several miles from Bosworth, two armies faced each other, ready for battle. The might of Richard III's army was pitted against the inferior forces of the upstart pretender to the crown, Henry Tudor, a twenty–eight year old Welshman who had just arrived back on British soil after fourteen years in exile. Yet this was to be a fight to the death—only one man could survive; only one could claim the throne. It would be the end of the War of the Roses.<br/><br/>It would become one of the most legendary battles in English history: the only successful invasion since Hastings, it was the last time a king died on the battlefield. But The Rise Of The Tudors is much more than the account of the dramatic events of that fateful day in August. It is a tale of brutal feuds and deadly civil wars, and the remarkable rise of the Tudor family from obscure Welsh gentry to the throne of England—a story that began sixty years earlier with Owen Tudor's affair with Henry V's widow, Katherine of Valois.<br/>Drawing on eyewitness reports, newly discovered manuscripts and the latest archaeological evidence, including the recent discovery of Richard III's remains, Chris Skidmore vividly recreates this battle-scarred world and the reshaping of British history and the monarchy.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Chris Skidmore
      </h2>
      
      <p class="authorDescription body article"><P>CHRIS SKIDMORE was born in Bristol, England in 1981. He taught history at Bristol University and is a Fellow of the Royal Historical Society. In 2010 he was elected as a British Member of Parliament.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3cef71e8